if (!customElements.get("images-toggler")) {
  customElements.define(
    "images-toggler",
    class ImagesToggler extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector(".js-view-form");
        this.savedView =
          localStorage.getItem("collection_images_view") || "with-model";
        this.onChange = this.onChange.bind(this);
        this.gridEl =
          document.getElementById("CollectionLoop") ||
          document.getElementById("SearchLoop");
      }

      connectedCallback() {
        if (!this.form || !this.gridEl) return;
        // uncomment if saving in Local Storage is needed
        // this.loadSettings();
        this.form.addEventListener("change", this.onChange);
      }

      disconnectedCallback() {
        this.form.removeEventListener("change", this.onChange);
      }

      updateGridClass() {
        // prevents loss of element during section rendering
        this.gridEl =
          document.getElementById("CollectionLoop") ||
          document.getElementById("SearchLoop");
        const isWithout = this.savedView === "without-model";
        this.gridEl.classList.toggle("without-model", isWithout);
      }

      loadSettings() {
        this.updateGridClass();
        const radio = this.form.querySelector(
          `input[value="${this.savedView}"]`
        );
        if (radio) radio.checked = true;
        this.classList.remove("idle");
      }

      onChange(event) {
        if (event.target.name === "images-view") {
          this.savedView = event.target.value;
          // localStorage.setItem("collection_images_view", this.savedView);
          this.updateGridClass();
        }
      }
    }
  );
}
